import KEY from "../clientVariables.json";

export default function generateSolrQuery(
  keywords,
  start = 0,
  rows = 10,
  sort = "posted_date desc",
  keywordsForORcondition
) {
  let mainQuery = "*:*"; // Default query
  const fqQueries = Object.keys(keywords)
    .map((field) => {
      const value = keywords[field];
      const encodedValue = encodeURIComponent(value);

      // Check if the field is "jobtitle" and update the main "q" parameter if true
      // if (field === "jobtitle") {
      //   // Use OR condition for multiple job titles, if needed
      //   mainQuery = `jobtitle:${encodedValue}`;
      //   return null; // Skip adding this to fq filter queries
      // }

      if (field === "location") {
        if (value.toLowerCase() === '"remote"' || value.toLowerCase() === "remote") {
          return "remote:1";
        }
        return `${field}:${encodedValue}`;
      }

      // Default case for fields other than "jobtitle"
      return `${field}:${encodedValue}`;
    })
    .filter(Boolean); // Remove any null values

  const fqQuery = fqQueries.length ? fqQueries.join("&fq=") : null;

  const buildQueryString = (params) => {
    const queryString = Object.entries(params)
      .filter(([, value]) => value !== null)
      .map(([key, value]) => `${key}=${value}`)
      .join("&");

    return queryString;
  };

  // const q_ = `${mainQuery}${fqQuery}`

  const queryParams = buildQueryString({
    "q.op": "OR",
    // q: mainQuery || "*:*",
    q: "*:*",
    fq: fqQuery,
    start: start,
    rows: rows,
    sort: sort,
  });

  return `${KEY?.solr}/${KEY?.candidate_jobs_solr}/select?${queryParams}`;
}
